import { pluralize } from "core/strings";
import { differenceInHours, format } from "date-fns";


const monthDay = (date) => format(date, "MMM d");
const brief = (date) => format(date, "MMM d, y");

const dynamic = (hours) => {
	if (!hours) return "";

	const _threshold = {
		day: 24,
		week: 168,
		month: 720
	};

	if (hours < _threshold.day) return ({ value: pluralize(hours, "hour"), type: "hour" }); // hours
	if (hours < _threshold.week) return ({ value: pluralize(Math.round(hours / _threshold.day), "day"), type: "day" }); // days
	if (hours < _threshold.month) return ({ value: pluralize(Math.round(hours / _threshold.week), "week"), type: "week" }); // weeks

	return ({ value: pluralize(Math.round(hours / _threshold.month), "month"), type: "month" }); // months
};

const hours = {
	toDays: (hours) => pluralize(Math.round(hours / 24), "day"),
	dynamic,
	difference: (later, earlier = new Date()) => differenceInHours(later, earlier)
};

export default { brief, monthDay, hours };